import {combineReducers} from 'redux'

import branchesReducer from 'app/modules/branches'

export default combineReducers({
  branchesData: branchesReducer,
})